import { mapGetters } from 'vuex';

export const controlMixin = {
    methods: {
        isControlVisible(refName,dataId,ignoreLoading){
            if(ignoreLoading){
                return this.$refs[refName] != null ? this.$refs[refName].l_visible : false
            }else{
                return !this.getWizardFormControl(dataId)?.isLoading ? (this.$refs[refName] != null ? this.$refs[refName].l_visible : false) : false;
            }
            
        },
        isControlDisabled(refName,dataId){
            return !this.getWizardFormControl(dataId)?.isLoading ? (this.$refs[refName] != null ? this.$refs[refName].getDisabled : false) : false;
            
        },
        isReversedControlDisabled(refName,dataId){
            return !this.getWizardFormControl(dataId)?.isLoading ? (this.$refs[refName] != null ? !this.$refs[refName].getDisabled : false) : false;
            
        }
    },
    computed:{
        ...mapGetters(['getWizardFormControl'])
    }
}